
export const AUTH_ENDPOINTS = {
    LOGIN: '/user/login',
    LOGOUT: '/user/logout',
    CHANGE_PASSWORD: '/change-password',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-forgot-password',
    RESET_USER_PASSWORD: '/reset-password',
    VALIDATE_PASSWORD: '/validate-password' 
};

export const USER_ENDPOINTS = {
    GET_ALL: '/user/get',
    CREATE: '/user/create',
    UPDATE: '/user/update',
    DELETE: '/user/delete',
    DELETE_USER: '/user/delete-user',
    PROFILE: '/user/profile',
    GET_BY_ID: '/user/find',
    GET_BY_UUID: '/user/get-user-by-uuid',
    GET_ALL_ROLES: '/user/get-all-roles',
    GET_LOCATIONS: '/user/get-location',
    GET_REGION:'/location/get-region',
    GET_AREA:'/location/get-area',
};

export const BORROWER_ENDPOINTS = {
    CREATE: '/borrower/create',
    GET_ALL: '/borrower/get',
    UPDATE: '/borrower/update',
    GET_BY_UUID: '/borrower/get-by-uuid',
    DELETE_BORROWER: '/borrower/delete-borrower',
};

export const LENDER_ENDPOINTS = {
    GET_ALL: '/lender/get-lender',
    GET_BY_ID: '/lender/get-lender-by-id',
    UPDATE: '/lender/update',
    CREATE: '/user-register',
};

export const CONSULTANT_ENDPOINTS = {
    CREATE: '/user-register',
    GET_ALL: '/get-users-by-type',
    GET_BY_ID: '/get-user-by-id',
    DELETE: '/delete-user',
};

export const LEADS_ENDPOINTS = {
    GET_LEADS: '/leads/get',
    GET_LEAD_DETAILS: '/leads/get',  // Since it's the same base URL with different parameters
    UPDATE_LEAD_STATUS: '/leads/update-status',
    DELETE_LEAD: '/leads/delete',
};

export const LOAN_ENDPOINTS = {
    GET_APPLICATION_DETAILS: 'api/loan/get-application-details',
    GET_ALL: 'api/loan/get-all',
    GET_ALL_PROPOSALS_CUSTOMIZED: 'api/loan/get-all-proposals-customized',
    DOWNLOAD_DOCUMENTS: 'api/documents/download'
};

export const PROPOSAL_ENDPOINTS = {
    GET_BY_ID_AND_STATUS: '/proposal/get-by-id-and-status'
};

export const OTP_ENDPOINTS = {
    SEND_OTP: '/send-otp',
    VERIFY_OTP: '/verify-otp',
    RESEND_OTP: '/resend-otp'
};

export const BLOGS_ENDPOINTS = {
    GET_BLOGS: '/api/blog/get-all',
    GET_BLOG_BY_ID: '/api/blog/get-by-id',
    CREATE_BLOG: '/api/blog/create',
    UPDATE_BLOG: '/api/blog/update',
    DELETE_BLOG: '/api/blog/delete',
    DELETE_IMAGE: '/api/blog/delete-image'
};
export const ELIGIBILITY_CALCULATOR_ENDPOINTS = {
    GET_REQUIREMENTS: '/api/eligibilty-calculator/get-all-requirements',
    CREATE_LEAD: '/api/leads',
    NOTIFY: '/api/notify',
    CALCULATE: '/api/eligibilty-calculator/calculate-eligibility'
};

export const NOTIFICATION_ENDPOINTS = {
    MARK_READ: '/api/notifications/mark-read',
    GET_NOTIFICATIONS: '/api/notifications'
};